import { createFileRoute } from "@tanstack/react-router";
import PromotedCardsManager from "@/pages/admin/PromotedCardsManager";

export const Route = createFileRoute("/admin/promoted-cards")({
  component: PromotedCardsManager,
});
